import * as React from 'react'

import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'

import questionGroups from 'modules/surveys/store/collections/questionGroups'
import QuestionGroup from 'modules/surveys/store/models/QuestionGroup'

export function useQuestionGroup(questionGroupId: number | null): {
  loading: boolean
  questionGroup: QuestionGroup | null | undefined
  refresh: () => Promise<void>
} {
  const [questionGroup, setQuestionGroup] = React.useState(
    questionGroupId && !isNaN(questionGroupId) ? questionGroups.get(questionGroupId) : null
  )

  const fetchQuestionGroup = async () => {
    if (!questionGroupId || isNaN(questionGroupId)) {
      return
    }

    if (questionGroup) {
      return questionGroup.fetch()
    }

    setQuestionGroup(
      await QuestionGroup.fetch({
        id: questionGroupId.toString(),
      })
    )
  }

  const { loading } = useUnsafeAsyncData(fetchQuestionGroup, [questionGroupId])

  return {
    loading,
    questionGroup,
    refresh: fetchQuestionGroup,
  }
}
